<template>
  <div class="article-item" :key="'essayNo-' + item.essayNo">
    <div class="item-header">
      <div class="author-img-con">
        <img class="author-img" :src="item.author.avatar?(checkQiNiuUrl(item.author.avatar)+'?imageView2/0/w/80/h/80/format/png'):'/image/avatar.png'" alt="">
      </div>
      <div class="author-con">
        <div class="author-name one-line">{{ item.author.nickname || '' }}</div>
        <div class="author-text one-line">{{ item.author.sign || ''}}</div>
      </div>
      <div class="btn-con">
        <div class="btn no-focous" v-if="!item.isFocused" @click="doFocous"></div>
        <div class="btn is-focous" v-else @click="doFocous"></div>
      </div>
    </div>
    <div class="hr-line"></div>
    <div class="article-con">
      <div class="sub-title" v-if="item.title">{{ item.title }}</div>
      <div class="sub-text">{{ contentShow ? (contentText || '') : (item.summary || '')  }}</div>
      <div class="transparent-bg" v-if="item.contentLength>150 && !contentShow"></div>
      <div class="look-all" v-if="item.contentLength>150 && !contentShow" @click="lookContent">更多</div>
      <div class="look-all" v-if="item.contentLength>150 && contentShow" @click="contentShow = false">收起</div>
    </div>
    <div class="media-con" v-if="essayFiles.length>0">
      <van-grid
          :border="true"
          :gutter="5"
          :column-num="essayFiles.length===1? 1 : essayFiles.length===4? 2 : 3"
          :style="{ 'width': (essayFiles.length===1||essayFiles.length===4) ? '66.66666%' : '100%' }"
      >
        <van-grid-item
            v-for="(file, i) in essayFiles"
            :key="i+''+file.fileAddr"
        >
          <div class="is-vedio" v-if="file.fileType==='VIDEO'" @click="videoShow(file)"></div>
          <van-image class="show-img" :src="file.showImg" @click="showImg(i)"/>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="open-link" v-if="linkObj" @click="linkClick(linkObj)">
      <div class="link-img-con" v-if="linkObj.logo">
        <img class="link-img" :src=" checkQiNiuUrl(linkObj.logo) + '?imageView2/0/w/56/h/56/format/png'" alt="">
      </div>
      <div class="link-title"><div class="text">{{ linkObj.title || '' }}</div></div>
    </div>
    <div class="other-con">
      <div class="line"></div>
      <div class="time-con">
        <div class="time">{{ item.gmtCreate }}</div>
        <div class="collect" :class="{'active': item.totalCollect-0}" @click="doCollect"><span class="icon"></span><span>{{(item.totalCollect-0) || '收藏' }}</span></div>
        <div class="approve" :class="{'active': item.isPraised}" @click="doPraise"><span class="icon"></span><span>{{(item.totalPraise-0) || '赞' }}</span></div>
      </div>
      <div class="approve-img-list" v-if="praiseUser.length>0">
        <div class="icon-top"></div>
        <div class="approve-img-con" v-for="(user, u) in praiseUser" :key="u">
          <img class="approve-img" :src="checkQiNiuUrl(user.avatar) + '?imageView2/0/w/56/h/56/format/png'" alt="">
        </div>
      </div>
    </div>

    <!--<van-popup
        v-model="contentShow"
        get-container="#app"
        round
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '86%' }"
        :safe-area-inset-bottom="true"
    >
      <div class="article-item-content-title">查看全文</div>
      <div class="article-item-content-text">{{ contentText }}</div>
    </van-popup>-->

    <!--<div class="bg-10px"></div>-->
  </div>
</template>

<script>
  import { getEssayByNo, doPraise, doCollect, getEssayContent } from '@/api/publish'
  import { doFocous } from '@/api/my'
  export default {
    components: {
    },
    props: {
      data: {//父组件的item
        type: Object,
        required: true
      }
    },
    data(){
      return {
        item: null,//数据源
        canDoPraise: false,//是否正在调用点赞接口
        canDoCollect: false,//是否正在调用收藏接口
        canDoFocous: false,//是否正在调用关注接口
        praiseUser: [],//点赞人员列表
        linkObj: null,//附加链接
        essayFiles: [],//文件
        showImgList: [],//预览图片列表
        contentShow: false,//是否展示全文
        contentText: '',//全文内容
      }
    },
    watch: {
      data:{
        handler(val){
          this.item = val
          this.initData()
        },
        immediate: true,
        deep: true
      }
    },
    created(){

    },
    methods: {
      initData(){
        if(this.item.praiseUser){ // 处理点赞用户
          if(this.item.praiseUser.length>24){
            this.praiseUser = this.item.praiseUser.slice(0, 24)
          }else {
            this.praiseUser = this.item.praiseUser
          }
        }else {
          this.praiseUser = []
        }
        if(this.item.link){ // 处理附加链接
          this.linkObj = Object.assign({}, this.item.link)
        }
        if(this.item.essayFiles){
          let essayFiles = Object.assign([], this.item.essayFiles)
          this.showImgList = []
          this.essayFiles = essayFiles.map(item=>{
            if(item.fileType==='VIDEO'){ // 文件类型，PICTURE-图片，VIDEO-视频
              item.showImg = this.checkQiNiuUrl(item.fileAddr) + '?vframe/jpg/offset/1.000/w/213/h/213'
              this.showImgList.push(this.checkQiNiuUrl(item.fileAddr) + '?vframe/jpg/offset/1.000/w/375')
            }else {
              item.showImg = this.checkQiNiuUrl(item.fileAddr) + '?imageView2/5/w/213/h/213/format/png'
              this.showImgList.push(this.checkQiNiuUrl(item.fileAddr)+'?imageView2/5/format/png/interlace/1/q/100')
            }
            return item
          })
        }
      },

      // 点赞/取消点赞
      doPraise(){
        if(this.canDoPraise){
          return false
        }
        this.canDoPraise = true
        let req = {
          essayNo: this.item.essayNo,
          userOpenid: this.session('userOpenId')
        }
        doPraise(req).then(res=>{
          this.canDoPraise = false
          if(res.code===200){
            this.item.isPraised = res.data
            this.getEssayByNo(req.essayNo)
          }
        })
      },
      // 收藏或取消收藏
      doCollect(){
        if(this.canDoCollect){
          return false
        }
        this.canDoCollect = true
        let req = {
          essayNo: this.item.essayNo,
          userOpenid: this.session('userOpenId')
        }
        doCollect(req).then(res=>{
          this.canDoCollect = false
          if(res.code===200){
            this.item.isCollected = res.data
            this.getEssayByNo(req.essayNo)
            if(res.data===false){
              this.$emit('cancelCollect')
            }
          }
        })
      },
      // 关注或取消关注
      doFocous(){
        if(this.canDoFocous){
          return false
        }
        this.canDoFocous = true
        let req = {
          focusUserOpenid: this.item.author.openid,
          userOpenid: this.session('userOpenId')
        }
        doFocous(req).then(res=>{
          this.canDoFocous = false
          if(res.code===200){
            this.item.isFocused = res.data
            this.$emit('doRefresh', {authorOpenId: this.item.author.openid, flag: res.data})
          }
        })
      },

      // 查看全文
      lookContent(){
        if(this.contentText && !this.contentShow){
          this.contentShow = true
        }else {
          let req = {essayNo: this.item.essayNo}
          getEssayContent(req).then(res=>{
            if(res.code===200){
              this.contentText = res.data.content
              this.contentShow = true
            }
          })
        }
      },


      // 附加链接点击
      linkClick(linkObj){// linkObj.linkType 链接类型，OUTSIDE：外部文章，INSIDE：内部文章，TEAM：群，SHOP：云店，GOODS：商品
        let obj = linkObj.linkType==='OUTSIDE'? linkObj.link : JSON.parse(linkObj.link);
        // console.log(obj)
        if(linkObj.linkType==='OUTSIDE'){ // 外部文章
          window.location.href = obj
        }else if(linkObj.linkType==='INSIDE'){ // 内部文章
          this.$router.push({name: 'articleDetail', query: {essayNo: obj.essayNo} })
        }else if(linkObj.linkType==='TEAM'){ // 社群
          this.$dialog({ closeOnClickOverlay: true, message: '请在 云柑社区APP 搜索并申请加入社群！</br> 群号: ' + obj.tid })
        }else if(linkObj.linkType==='SHOP'){ // 云店
          this.$router.push({name: 'mallShop', query: {shopId: obj.shopId} })
        }else if(linkObj.linkType==='GOODS'){ // 微课商品
          this.$router.push({name: 'goodsDetail', query: {goodsId: obj.goodsId, shopId: obj.shopId, courseType: obj.courseType} })
        }else if(linkObj.linkType==='SGSHOP'){ // 省购店
          this.$router.push({name: 'sgShopIndex', query: {shopId: obj.shopId} })
        }else if(linkObj.linkType==='JDGOODS'){ // 京购商品
          this.$router.push({name: 'jdGoodsDetail', query: {goodsId: obj.goodsId, shopId: obj.shopId} })
        }
      },

      //预览图片
      showImg(i){
        this.showImagePreview({images: this.showImgList, startPosition: i})
      },

      // 预览视频
      videoShow(file){
        console.log(file)
        if(file.fileType==='VIDEO'){
          let url = this.checkQiNiuUrl(file.fileAddr)
          if(file.fileAddr){
            this.$store.dispatch('video/setVideoSrc', url)
          }
        }
      },

      // 刷新单条数据
      getEssayByNo(essayNo){
        let req = {essayNo}
        getEssayByNo(req).then(res=>{
          if(res.code===200){
            this.item = res.data
            this.initData()
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .article-item{
    border-radius: 5px;
    background-color: #fff;
    margin-bottom: 10px;
    .item-header{
      display: flex;
      .author-img-con{
        display: inline-flex;justify-content: center;align-items: center;height: 68px;width: 68px;
        .author-img{width: 40px;height: 40px;display: block;border-radius: 50%;}
      }
      .author-con{
        display: inline-flex;flex: 1;
        flex-direction: column;justify-content: center;
        overflow: hidden;
        .author-name{font-size: 16px;color: #333;}
        .author-text{font-size: 12px;color: #666;}
      }
      .btn-con{
        padding-right: 15px;display: inline-flex;align-items: center;
        .btn{
          height: 28px;font-size: 14px;
          display: inline-flex;justify-content: center;align-items: center;
          &.no-focous{
            width: 60px;
            background: url("./img/focous-false.png") no-repeat 50% 50%;background-size: 100%;
          }
          &.is-focous{
            width: 73px;
            background: url("./img/focous-true.png") no-repeat 50% 50%;background-size: 100%;
          }
        }
      }
    }
    .hr-line{border-top: 1px solid #dedede;margin: 0 14px;}
    .article-con{
      position: relative;
      font-size: 16px;
      padding: 0 15px 10px;
      word-wrap: break-word;
      white-space: pre-wrap;
      color: #333;
      overflow: hidden;
      .sub-title{font-size: 16px;font-weight: bold;line-height: 23px;padding: 10px 0 4px;}
      .sub-text{}
      .transparent-bg{
        position: absolute;
        bottom: 47px;
        width: 100%;
        height: 50px;
        background-image: linear-gradient(transparent, #fff);
      }
      .look-all{
        margin: 8px 0 12px;
        font-size: 13px;
        color: #1585f3;
      }
    }
    .media-con{
      padding: 0 10px;
      margin-bottom: 15px;
      .is-vedio{
        position: absolute;z-index: 1;width: 100%;height: 100%;
        background: rgba(0,0,0,.4) url("./img/paly-btn.png") no-repeat 50% 50%;
        background-size: 35px 35px;
      }
      .show-img{
        width: 100%;
        height: 100%;
      }
    }
    .open-link{
      display: flex;margin: 0 15px 15px;
      background-color: #f5f5f5;
      .link-img-con{
        display: inline-flex;width: 45px;height: 45px;
        justify-content: center;align-items: center;
        .link-img{
          display: block;width: 40px;height: 40px;
        }
      }
      .link-title{
        padding-left: 10px;
        display: inline-flex;align-items: flex-start;
        font-size: 14px;color: #333;
        padding-top: 4px;
        .text{
          color: #1585f3;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

      }
    }
    .other-con{
      padding: 0 15px 10px;
      .line{
        border-top: 1px solid #dedede;
      }
      .time-con{
        display: flex;
        .time{
          display: inline-flex;
          line-height: 34px;
          flex: 1;
          color: #666;
          font-size: 10px;
        }
        .collect{
          display: inline-flex;width: 76px;line-height: 34px;
          justify-content: center;align-items: center;
          font-size: 14px;
          .icon{
            display: block;width: 16px;height: 14px;margin-right: 8px;
            background: url("./img/collect.png") no-repeat 50% 50%;
            background-size: 100%;
          }
          &.active{
            color: #1585f3;
            .icon{
              width: 16px;height: 14px;
              background: url("./img/collect-active.png") no-repeat 50% 50%;
              background-size: 100%;
            }
          }
        }
        .approve{
          display: inline-flex;width: 76px;line-height: 34px;
          justify-content: center;align-items: center;
          font-size: 14px;
          .icon{
            display: block;width: 14px;height: 14px;margin-right: 8px;
            background: url("./img/approve.png") no-repeat 50% 50%;
            background-size: 100%;
          }
          &.active{
            color: #1585f3;
            .icon{
              width: 14px;height: 14px;
              background: url("./img/approve-active.png") no-repeat 50% 50%;
              background-size: 100%;
            }
          }
        }
      }
      .approve-img-list{
        position: relative;
        background-color: #f5f5f5;border-radius: 5px;
        display: flex;flex-wrap: wrap;padding-bottom: 5px;
        .icon-top{
          position: absolute;
          width: 9px;height: 6px;
          top: -6px;right: 36px;
          background: url("./img/icon-top.png") no-repeat 50% 100%;
          background-size: 9px 5.5px;
        }
        .approve-img-con{
          display: inline-flex;justify-content: center;align-items: center;
          box-sizing: border-box;
          padding-right: 2px;
          flex-basis: 12.5%;
          margin-top: 5px;
          .approve-img{
            display: block;
            width: 28px;height: 28px;
            border-radius: 50%;
          }
        }
      }
    }

  }
</style>
<style lang="less">
  .article{
    .article-list{
      .van-grid-item__content{padding: 0;}
    }
  }
  .article-item-content-title{
    font-size: 15px;color: #000;
    text-align: center;line-height: 40px;
  }
  .article-item-content-text{
    width: 375px;
    height: 92%;
    overflow: auto;
    font-size: 15px;
    padding: 15px;
    text-indent: 2em;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
</style>
